import React from "react";
import PropTypes from "prop-types";
import {
    Card,
    CardBody,
    Row,
    Col,
    CardTitle,
    CardImg
} from "reactstrap";
import data_tematica from "../data/tematica.json";

import { NavLink } from "react-router-dom";
class Tematica extends React.Component {
    static contextTypes = {
        router: PropTypes.object
    }
    constructor(props) {
        super(props);
        let me = this;
        me.state = {
            active: ""
        };
        me.goToIndicadores = me.goToIndicadores.bind(me);
        me.onImageMouseOver = me.onImageMouseOver.bind(me);
    }
    componentDidMount() {

    }
    goToIndicadores(e) {
        e.preventDefault();
        this.props.history.push('./indicador');
    }
    onImageMouseOver(idTematica) {
        this.setState({ active: idTematica });
    }
    onImageMouseOut() {
        this.setState({ active: "" });
    }
    render() {
        let me = this;
        const { active } = this.state;
        return (
            <div className="container mt-2">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col xs={12} sm={12} md={12} xl={12}>
                                        <Row className="text-center">
                                            <Col>
                                                <p className="h4 text-secondary">
                                                    Temáticas Ambientales
                                        </p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <Row className="mt-2">
                                {data_tematica.map((item, key) => {
                                    return <Col xs={12} sm={6} md={6} xl={6} >
                                        <Card className="card-header-top-bottom-line">
                                            <Row className="mb-1 ml-1">
                                                <Col xs={4} sm={12} md={3} xl={3}>
                                                    <div>
                                                        <NavLink
                                                            key={item.id_serie}
                                                            to={`./indicador?tematica=${item.id}`}
                                                        >
                                                            <CardImg key={key} className="img-thumbnail mx-auto d-block"
                                                                src={`https://sinia.minam.gob.pe/informacion/imagenes/tematicas/${item.id}_${
                                                                    active === item.id ? "azul" : "verde"
                                                                    }.png`}
                                                                alt={item.nombre}
                                                                onMouseOver={() => me.onImageMouseOver(item.id)}
                                                                onMouseOut={() => me.onImageMouseOut(item.id)}
                                                                title={"Click para ir a " + item.nombre} />
                                                        </NavLink>
                                                    </div>
                                                </Col>
                                                <Col xs={8} sm={12} md={9} xl={9}>
                                                    <CardBody>
                                                        <CardTitle>
                                                            <NavLink
                                                                key={item.id_serie}
                                                                to={`./indicador?tematica=${item.id}`}
                                                            >
                                                                <p className="h6 text-secondary">{item.nombre}</p>
                                                            </NavLink></CardTitle>
                                                    </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                }
                                )}
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Tematica;
